import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  className = '' 
}) => {
  const getVariantClasses = (variant: string) => {
    switch (variant) {
      case 'secondary':
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200';
      case 'destructive':
        return 'bg-red-100 text-red-800 hover:bg-red-200';
      case 'outline':
        return 'border border-gray-200 text-gray-800 hover:bg-gray-100';
      default:
        return 'bg-blue-100 text-blue-800 hover:bg-blue-200';
    }
  };

  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
        transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
        ${getVariantClasses(variant)}
        ${className}
      `}
    >
      {children}
    </span>
  );
};

export default Badge;